import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Chip } from '@material-ui/core'
import { twMerge } from 'tailwind-merge'

import {
  UNAVAILABLE,
  AVAILABLE,
  NORMAL,
  DISTRESS,
  ACCENT,
  ERROR,
  INACTIVE,
} from 'app/constants/statusColors'

const useStyles = makeStyles({
  chip: {
    minWidth: '90px',
  },
})

const StatusChip = (props) => {
  const { type, label, className = '' } = props
  const classes = useStyles()

  const handleColor = () => {
    switch (type) {
      case UNAVAILABLE:
        return 'border-1 border-grey-300 bg-neutrals-50 text-grey-300'
      case AVAILABLE:
        return 'border-1 border-primary text-primary bg-primary-200'
      case NORMAL:
        return 'border-1 border-green-600 text-green-600 bg-green-50'
      case DISTRESS:
        return 'border-1 border-orange-600 text-orange-600 bg-orange-50'
      case ACCENT:
        return 'border-1 border-indigo-600 text-indigo-600 bg-indigo-50'
      case ERROR:
        return 'border-1 border-red-500 text-red-500 bg-red-50'
      case INACTIVE:
        return 'border-1 text-grey-neutral'
      default:
        return
    }
  }

  return (
    <Chip
      label={label}
      variant="outlined"
      className={twMerge(
        classes.chip,
        'capitalize text-14 font-normal',
        handleColor(),
        className,
      )}
    />
  )
}

StatusChip.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default StatusChip
